import axios from 'axios';

// 1. Base URL configuration (dynamically routes to PHP backend on port 8000 during local dev, and relative /api in prod)
const resolveApiUrl = (): string => {
  const port = window.location.port;
  if (port && port !== '8000') {
    return `http://${window.location.hostname}:8000/api`;
  }
  return '/api';
};

const API_URL = resolveApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Parses current window domain to dynamically resolve the school subdomain
 */
const resolveActiveSubdomain = (): string => {
  const host = window.location.host;
  const parts = host.split('.');

  // If running in production context (e.g. morenese.smartschools.com)
  if (parts.length >= 3 && parts[0] !== 'localhost' && !/^[0-9.]+$/.test(parts[0])) {
    return parts[0];
  }
  
  // Developer default mapping for local development
  return 'morenese';
};

// 2. Request Interceptor: Inject Tenant Subdomain and Authorization Token
api.interceptors.request.use(
  (config) => {
    // Inject Subdomain to let middleware parse tenant scope
    config.headers['X-Tenant-Subdomain'] = resolveActiveSubdomain();

    // Inject active JWT Bearer Token if present in local state
    const token = localStorage.getItem('school_saas_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. Response Interceptor: Catch global access revocations (Expired Tokens)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear expired credentials
      localStorage.removeItem('school_saas_token');
      localStorage.removeItem('school_saas_user');

      // Bounce back to login unless already there
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
